import Button from '@mui/material/Button';
import _ from 'lodash';
import React from 'react';

const buttonStyle = { minWidth: '15px', marginRight: '5px' };

class DayOfWeekSelectionComponent extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {days:0};
  }

  render() {
    const { selected, toggle, disabled } = this.props;
    // selected = [true, false, true, true, true, true, false] then =  2**1 + 2**3

    return (
      <div>
        <div style={{ textAlign: 'center' }}> Schedule Days </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <SpecialButton
            label="Mon"
            disabled={disabled}
            selected={selected}
            number={0}
            style={buttonStyle}
            toggle={toggle}
          />
          <SpecialButton
            label="Tue"
            disabled={disabled}
            selected={selected}
            number={1}
            style={buttonStyle}
            toggle={toggle}
          />
          <SpecialButton
            label="Wed"
            disabled={disabled}
            selected={selected}
            number={2}
            style={buttonStyle}
            toggle={toggle}
          />
          <SpecialButton
            label="Thu"
            disabled={disabled}
            selected={selected}
            number={3}
            style={buttonStyle}
            toggle={toggle}
          />
          <SpecialButton
            label="Fri"
            disabled={disabled}
            selected={selected}
            number={4}
            style={buttonStyle}
            toggle={toggle}
          />
          <SpecialButton
            label="Sat"
            disabled={disabled}
            selected={selected}
            number={5}
            style={buttonStyle}
            toggle={toggle}
          />
          <SpecialButton
            label="Sun"
            disabled={disabled}
            selected={selected}
            number={6}
            style={buttonStyle}
            toggle={toggle}
          />
        </div>
        <div
          style={{
            fontSize: '12px',
            color: 'var(--text-secondary)',
            paddingTop: '2px',
            textAlign: 'center',
          }}
        >
          (blue means selected)
        </div>
        {_.every(selected, v => v === false) ? (
          <div style={{ color: 'var(--md-error)', textAlign: 'center' }}>
            <i className="fas fa-exclamation-triangle" /> You cannot submit a schedule with no days selected.{' '}
          </div>
        ) : null}
      </div>
    );
  }
}

export default DayOfWeekSelectionComponent;

const SpecialButton = ({ label, selected, number, disabled, toggle }) => (
  <Button
    variant="contained"
    color={selected[number] ? 'primary' : 'secondary'}
    style={buttonStyle}
    onClick={() => toggle(number)}
    disabled={disabled}
  >
    {label}
  </Button>
);
